import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_1: FaireProductEntity = {
  token: "viverano-1",
  type: "product",
  name: "Milan Pastel Baby Blanket Sweater Knit (Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/12fc36c46a07c2eba7e2961b96540868d3e8eed7a59b8988bff09d0a11bdef80.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 28.5,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
